<p>project-details works!</p>
